import { theme } from '@frontend/theme';
import { AI_RECEPTIONIST_STATE_BACKGROUND_GRADIENT } from '../grouped-notifications/filter-chips/constants';

const { colors } = theme;

export const colorMap = {
  primary: {
    progress: colors.primary30,
    background: colors.primary5,
    hover: colors.primary10,
    primary: colors.primary50,
  },
  critical: {
    progress: colors.critical30,
    background: colors.critical5,
    hover: colors.critical10,
    primary: colors.critical50,
  },
  seaweed: {
    progress: colors.secondary.seaweed30,
    background: colors.secondary.seaweed5,
    hover: colors.secondary.seaweed10,
    primary: colors.secondary.seaweed50,
  },
  indigo: {
    progress: colors.indigo30,
    background: colors.indigo5,
    hover: colors.indigo10,
    primary: colors.indigo50,
  },
  rose: {
    progress: colors.rose30,
    background: colors.rose5,
    hover: colors.rose10,
    primary: colors.rose50,
  },
  warning: {
    progress: colors.warning30,
    background: colors.warning5,
    hover: colors.warning10,
    primary: colors.warning60,
  },
  tangerine: {
    progress: colors.tangerine30,
    background: colors.tangerine5,
    hover: colors.tangerine10,
    primary: colors.tangerine50,
  },
  neutral: {
    progress: colors.neutral30,
    background: colors.neutral5,
    hover: colors.neutral10,
    primary: colors.neutral50,
  },
  eggplant: {
    progress: colors.secondary.eggplant30,
    background: colors.secondary.eggplant5,
    hover: colors.secondary.eggplant10,
    primary: colors.secondary.eggplant50,
  },
  success: {
    progress: colors.success30,
    background: colors.success5,
    hover: colors.success10,
    primary: colors.success50,
  },
  /**
   * Going to add this as a gradient for now. If we get use cases where there's different gradients
   * we can refactor this to be more flexible.
   */
  gradient: {
    background: 'gradient',
    hover: 'gradient',
    primary: colors.neutral70,
    progress: 'linear-gradient(92.94deg, #146ef5 48.5%, #c467de 100%)',
  },
  skyBlueGradient: {
    background: AI_RECEPTIONIST_STATE_BACKGROUND_GRADIENT,
    hover: AI_RECEPTIONIST_STATE_BACKGROUND_GRADIENT,
    primary: '#E0F9F9',
    progress: '#E0F9F9',
  },
} satisfies Record<
  string,
  {
    primary: string;
    hover: string;
    progress: string;
    background: string;
  }
>;

export type ColorMap = typeof colorMap;
